import { useEffect, useState } from "react";
// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
 
import { ImageViewer } from "react-image-viewer-dv";
// Acromegaly React components
import MDBox from "components/MDBox";
import Swal from "sweetalert2";
import LoadingOverlay from "react-loading-overlay";
// Acromegaly React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
 // Acromegaly React contexts
import { useMaterialUIController, setDirection } from "context";
import { useLocation, useNavigate, useParams } from "react-router-dom";
 
import config from "config";
import MDTypography from "components/MDTypography";
import Footer from "examples/Footer";

import { getOrderLogList } from "controllers/OrderController";

const sorts = {};

// const endUserContactTyps = ["اینستاگرام", "سایت", "حضوری"];
// const endUserSendTypes = ["تیپاکس", "پست پیشتاز", "پست ویژه", "کوشا", "باربری", "پیک", "حضوری"];
function OrderLog() {
  const [controller, dispatch] = useMaterialUIController();
  const [loading, setLoading] = useState(false);

  const [datas, setDatas] = useState([]);

  const navigate = useNavigate();
  const location = useLocation();
  const { order } = useParams();

  // Avoid a layout jump when reaching the last page with empty rows.
  const getData = async () => {
    setLoading(true);
    const data = await getOrderLogList({ order }, controller.token);
    if (data.success) {
      setDatas(data.data);
    } else {
      Swal.fire({
        text: data.message,
        icon: "error",
        confirmButtonText: "بسیار خوب",
      });

      if (data.code === 401) {
        navigate("/", { replace: true });
      }
    }

    setLoading(false);
  };

  useEffect(() => {
    if (["supperadmin"].filter((a) => a == controller.userRole).length == 0) {
      navigate("/dashboard", { replace: true });
      return;
    }
    setDirection(dispatch, "rtl");

    //

    getData();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar title="لیست سفارشات" />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={1}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <Grid
                  container
                  spacing={1}
                  style={{
                    alignItems: "center",
                  }}
                >
                  <Grid item xs={12} sm={4}>
                    <MDTypography variant="h6" fontWeight="medium" color="white">
                      تغییرات اطلاعات سفارش
                    </MDTypography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={8}
                    style={{
                      justifyContent: "flex-end",
                      alignItems: "center",
                      float: "left",
                    }}
                  >
                
                  </Grid>
                </Grid>
              </MDBox>
              <MDBox pt={3}>
                <LoadingOverlay
                  className="overlayclass"
                  active={loading}
                  spinner
                  text="لطفا کمی صبر کنید"
                >
                  {datas.map((row, index) => (
                    <div className="borderdtbltr">
                      <Grid container px={1}>
                        <Grid lg={12} md={12} xs={12} style={{ textAlign: "left" }}>
                          {`${row.user}  [${row.createdAt}]`}
                        </Grid>
                      </Grid>

                      {row.picture && (
                        <Grid container px={1}>
                          <Grid lg={2} md={4} xs={12} style={{ textAlign: "rigth" }}></Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            <div
                              style={{
                                maxWidth: 55,
                                maxHeight: 55,
                                width: "100%",
                                overflow: "hidden",
                              }}
                            >
                              <ImageViewer>
                                <img
                                  src={`${config.fileserver}product/${row.picturex}`}
                                  style={{ width: "100%", resize: "center" }}
                                  alt="گالری محتشم"
                                />
                              </ImageViewer>
                            </div>
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            <div
                              style={{
                                maxWidth: 55,
                                maxHeight: 55,
                                width: "100%",
                                overflow: "hidden",
                              }}
                            >
                              <ImageViewer>
                                <img
                                  src={`${config.fileserver}product/${row.picture}`}
                                  style={{ width: "100%", resize: "center" }}
                                  alt="گالری محتشم"
                                />
                              </ImageViewer>
                            </div>
                          </Grid>
                        </Grid>
                      )}
                      {row.explanation && (
                        <Grid container px={1}>
                          <Grid lg={2} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            <b style={{ color: "#000066" }}> شرح محصول: </b>
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.explanationx}
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.explanation}
                          </Grid>
                        </Grid>
                      )}

                      {row.material && (
                        <Grid container px={1}>
                          <Grid lg={2} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            <b style={{ color: "#000066" }}>جنس محصول: </b>
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.materialx}
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.material}
                          </Grid>
                        </Grid>
                      )}
                      {row.type && (
                        <Grid container px={1}>
                          <Grid lg={2} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            <b style={{ color: "#000066" }}> نوع محصول: </b>
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.typex}
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.type}
                          </Grid>
                        </Grid>
                      )}
                      {row.buildType && (
                        <Grid container px={1}>
                          <Grid lg={2} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            <b style={{ color: "#000066" }}> نوع ساخت: </b>
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.buildTypex}
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.buildType}
                          </Grid>
                        </Grid>
                      )}
                      {row.collaborator && (
                        <Grid container px={1}>
                          <Grid lg={2} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            <b style={{ color: "#000066" }}> سفارش دهنده: </b>
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.collaboratorx}
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.collaborator}
                          </Grid>
                        </Grid>
                      )}
                      {row.deliveryDate && (
                        <Grid container px={1}>
                          <Grid lg={2} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            <b style={{ color: "#000066" }}>تاریخ تحویل : </b>
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.deliveryDatex}
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.deliveryDate}
                          </Grid>
                        </Grid>
                      )}
                      {row.weight && (
                        <Grid container px={1}>
                          <Grid lg={2} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            <b style={{ color: "#000066" }}> وزن کل درخواستی: </b>
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.weightx}
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.weight}
                          </Grid>
                        </Grid>
                      )}
                      {row.pelakWeight && (
                        <Grid container px={1}>
                          <Grid lg={2} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            <b style={{ color: "#000066" }}> وزن پلاک درخواستی: </b>
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.pelakWeightx}
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.pelakWeight}
                          </Grid>
                        </Grid>
                      )}
                      {row.zanjirWeight && (
                        <Grid container px={1}>
                          <Grid lg={2} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            <b style={{ color: "#000066" }}> وزن زنجیر درخواستی: </b>
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.zanjirWeightx}
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.zanjirWeight}
                          </Grid>
                        </Grid>
                      )}

                      {row.height && (
                        <Grid container px={1}>
                          <Grid lg={2} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            <b style={{ color: "#000066" }}>طول: </b>
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.heightx}
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.height}
                          </Grid>
                        </Grid>
                      )}
                      {row.width && (
                        <Grid container px={1}>
                          <Grid lg={2} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            <b style={{ color: "#000066" }}>عرض: </b>
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.widthx}
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.width}
                          </Grid>
                        </Grid>
                      )}
                      {row.thickness && (
                        <Grid container px={1}>
                          <Grid lg={2} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            <b style={{ color: "#000066" }}>ضخامت: </b>
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.thicknessx}
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.thickness}
                          </Grid>
                        </Grid>
                      )}
                      {row.plating && (
                        <Grid container px={1}>
                          <Grid lg={2} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            <b style={{ color: "#000066" }}>آبکاری: </b>
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.platingx}
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.plating}
                          </Grid>
                        </Grid>
                      )}
                      {row.orderState && (
                        <Grid container px={1}>
                          <Grid lg={2} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            <b style={{ color: "#000066" }}>وضعیت سفارش: </b>
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.orderStatex}
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.orderState}
                          </Grid>
                        </Grid>
                      )}
                      {row.belongings && (
                        <Grid container px={1}>
                          <Grid lg={2} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            <b style={{ color: "#000066" }}>متعلقات : </b>
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.belongingsx}
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.belongings}
                          </Grid>
                        </Grid>
                      )}
                      {row.description && (
                        <Grid container px={1}>
                          <Grid lg={2} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            <b style={{ color: "#000066" }}>توضیحات : </b>
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.descriptionx}
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.description}
                          </Grid>
                        </Grid>
                      )}

                      {/* <Grid container px={1}>
                        <MDTypography variant="h6" fontWeight="medium" color="white">
                          مشخصات مشتری
                        </MDTypography>
                      </Grid> */}
                      {row.endUserName && (
                        <Grid container px={1}>
                          <Grid lg={2} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            <b style={{ color: "#000066" }}>اسم مشتری : </b>
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.endUserNamex}
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.endUserName}
                          </Grid>
                        </Grid>
                      )}
                      {row.endUserAddress && (
                        <Grid container px={1}>
                          <Grid lg={2} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            <b style={{ color: "#000066" }}>آدرس مشتری : </b>
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.endUserAddressx}
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.endUserAddress}
                          </Grid>
                        </Grid>
                      )}
                      {row.endUserPhone && (
                        <Grid container px={1}>
                          <Grid lg={2} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            <b style={{ color: "#000066" }}>شماره تماس مشتری : </b>
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.endUserPhonex}
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.endUserPhone}
                          </Grid>
                        </Grid>
                      )}
                      {row.endUserContactTyp && (
                        <Grid container px={1}>
                          <Grid lg={2} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            <b style={{ color: "#000066" }}>نحوه ارتباط مشتری : </b>
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.endUserContactTypx}
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.endUserContactTyp}
                          </Grid>
                        </Grid>
                      )}
                      {row.endUserSendType && (
                        <Grid container px={1}>
                          <Grid lg={2} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            <b style={{ color: "#000066" }}>نحوه ارسال : </b>
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.endUserSendTypex}
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.endUserSendType}
                          </Grid>
                        </Grid>
                      )}
                      {row.endUserPostalCode && (
                        <Grid container px={1}>
                          <Grid lg={2} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            <b style={{ color: "#000066" }}>کدپستی : </b>
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.endUserPostalCodex}
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.endUserPostalCode}
                          </Grid>
                        </Grid>
                      )}

                      {row.collaboratorWeight && (
                        <Grid container px={1}>
                          <Grid lg={2} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            <b style={{ color: "#000066" }}>وزن تحویلی به همکار: </b>
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.collaboratorWeightx}
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.collaboratorWeight}
                          </Grid>
                        </Grid>
                      )}

                      {row.collaboratorDate && (
                        <Grid container px={1}>
                          <Grid lg={2} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            <b style={{ color: "#000066" }}> تاریخ تحویل به همکار: </b>
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.collaboratorDatex}
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.collaboratorDate}
                          </Grid>
                        </Grid>
                      )}
                      {row.wages && (
                        <Grid container px={1}>
                          <Grid lg={2} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            <b style={{ color: "#000066" }}> اجرت همکار: </b>
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.wagesx}
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.wages}
                          </Grid>
                        </Grid>
                      )}

                      {row.endUserPrice1 && (
                        <Grid container px={1}>
                          <Grid lg={2} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            <b style={{ color: "#000066" }}> قیمت درخواستی مشتری: </b>
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.endUserPrice1x}
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.endUserPrice1}
                          </Grid>
                        </Grid>
                      )}
                      {row.endUserPrice2 && (
                        <Grid container px={1}>
                          <Grid lg={2} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            <b style={{ color: "#000066" }}> بیعانه: </b>
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.endUserPrice2x}
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.endUserPrice2}
                          </Grid>
                        </Grid>
                      )}

                      {row.endDate && (
                        <Grid container px={1}>
                          <Grid lg={2} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            <b style={{ color: "#000066" }}>تاریخ تحویل به مشتری: </b>
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.endDatex}
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.endDate}
                          </Grid>
                        </Grid>
                      )}
                      {row.goldDayPrice && (
                        <Grid container px={1}>
                          <Grid lg={2} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            <b style={{ color: "#000066" }}>قیمت روز طلا: </b>
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.goldDayPricex}
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.goldDayPrice}
                          </Grid>
                        </Grid>
                      )}
                      {row.materialPrice && (
                        <Grid container px={1}>
                          <Grid lg={2} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            <b style={{ color: "#000066" }}>قیمت متریال: </b>
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.materialPricex}
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.materialPrice}
                          </Grid>
                        </Grid>
                      )}
                      {row.endWages && (
                        <Grid container px={1}>
                          <Grid lg={2} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            <b style={{ color: "#000066" }}>اجرت مشتری: </b>
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.endWagesx}
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.endWages}
                          </Grid>
                        </Grid>
                      )}
                      {row.postPrice && (
                        <Grid container px={1}>
                          <Grid lg={2} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            <b style={{ color: "#000066" }}>هزینه ارسال: </b>
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.postPricex}
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.postPrice}
                          </Grid>
                        </Grid>
                      )}
                      {row.platingPrice && (
                        <Grid container px={1}>
                          <Grid lg={2} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            <b style={{ color: "#000066" }}>هزینه آبکاری: </b>
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.platingPricex}
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.platingPrice}
                          </Grid>
                        </Grid>
                      )}
                      {row.factorNumber && (
                        <Grid container px={1}>
                          <Grid lg={2} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            <b style={{ color: "#000066" }}>شماره فاکتور: </b>
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.factorNumberx}
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.factorNumber}
                          </Grid>
                        </Grid>
                      )}
                      {row.sellPrice && (
                        <Grid container px={1}>
                          <Grid lg={2} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            <b style={{ color: "#000066" }}>قیمت فروش: </b>
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.sellPricex}
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.sellPrice}
                          </Grid>
                        </Grid>
                      )}
                      {row.profit && (
                        <Grid container px={1}>
                          <Grid lg={2} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            <b style={{ color: "#000066" }}>سود: </b>
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.profitx}
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.profit}
                          </Grid>
                        </Grid>
                      )}
                      {row.endWeight && (
                        <Grid container px={1}>
                          <Grid lg={2} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            <b style={{ color: "#000066" }}>وزن تحویلی به مشتری: </b>
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.endWeightx}
                          </Grid>
                          <Grid lg={5} md={4} xs={12} style={{ textAlign: "rigth" }}>
                            {row.endWeight}
                          </Grid>
                        </Grid>
                      )}
                    </div>
                  ))}
                </LoadingOverlay>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default OrderLog;
